module.exports = __webpack_public_path__ + "fonts/fa-brands-400.64bfc3b3.woff2";